import { Component, EventEmitter, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthClient, EducatorVerificationStepTwoContactCommand } from 'src/shared/services/api.service';
import { catchValidationErrors } from 'src/shared/validation/validator-utilities';

@Component({
  standalone: false,
  selector: 'edportal-educator-verification-step-two-contact',
  templateUrl: './educator-verification-step-two-contact.component.html',
  styles: ``,
})
export class EducatorVerificationStepTwoContactComponent {
  @ViewChild('stepTwoForm') form!: NgForm;
  stepTwoCommand: EducatorVerificationStepTwoContactCommand = {};
  errorEmitter = new EventEmitter<any>();

  constructor(
    private readonly authClient: AuthClient,
    private readonly router: Router,
  ) {}

  onContinue() {
    this.authClient
      .completeStepTwoVerificationContact(this.stepTwoCommand)
      .pipe(catchValidationErrors(this.form, this.errorEmitter))
      .subscribe((complete) => {
        if (complete) {
          this.router.navigate(['/verify/success'], { replaceUrl: true });
        } else {
          this.router.navigate(['/verify/failed'], { replaceUrl: true });
        }
      });
  }
}
